import { useMemo } from 'react';
// eslint-disable-next-line @atlaskit/design-system/no-unsupported-drag-and-drop-libraries
import type { DroppableStateSnapshot } from 'react-beautiful-dnd';

export const useReactBeautifulDnDElementHeight = (dndSnapshot: DroppableStateSnapshot) =>
	useMemo(() => {
		if (dndSnapshot.draggingFromThisWith != null) {
			return 0;
		}

		if (dndSnapshot.draggingOverWith == null) {
			return 0;
		}

		const element = document.querySelector(
			`[data-rbd-draggable-id="${dndSnapshot.draggingOverWith}"]`,
		);
		return element ? element.clientHeight : 0;
	}, [dndSnapshot.draggingFromThisWith, dndSnapshot.draggingOverWith]);
